// extracted by mini-css-extract-plugin
module.exports = {"redesignedSwitcher":"styles-module-redesignedSwitcher--hXxfi"};